import type { FC } from 'react'
import AddToCartConfirmationButtons from './AddToCartConfirmationButtons'
import SmBreakpoint from '@g4g/ui/src/utility/SmBreakpoint'
import AddedToCartIcon from '../../shared/AddedToCartIcon'

const AddToCartConfirmationTopRow: FC<{ wasUpdate?: boolean }> = ({ wasUpdate }) => (
  <div className="flex flex-col p-0 sm:space-y-2 lg:space-y-0 sm:pt-4 lg:pt-6 lg:flex-row">
    <div className="flex items-center flex-grow space-x-2">
      <AddedToCartIcon />
      <h2 className="text-2xl font-bold font-poppins text-shopStdGreen">
        {wasUpdate ? 'Cart updated' : 'Added to cart'}
      </h2>
    </div>
    <SmBreakpoint min={<AddToCartConfirmationButtons />} />
  </div>
)

export default AddToCartConfirmationTopRow
